export default __webpack_public_path__ + "static/media/lens-logo.34867d93.svg";